import axios from 'axios';

import { Tenant, TenantSummary, ListResponse, ApiConfig, PartialUpdateEntity } from '../types';
import { toSerializedError } from '../errors/utils';

export type ListTenantsResponse = ListResponse<TenantSummary>;

export async function listTenants(
  { api_url, headers }: ApiConfig,
) {
  try {
    let res = await axios.get<ListTenantsResponse>(api_url+'/api/users/me/tenants', {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type CreateTenantParams = Pick<Tenant, 'name'|'title'|'description'> & { without_postfix?: boolean };
export type CreateTenantResponse = {
  tenant_id: string;
  request_id: string;
};

export async function createTenant(
  { api_url, headers }: ApiConfig,
  body: CreateTenantParams
) {
  try {
    let res = await axios.post<CreateTenantResponse>(api_url+'/api/users/me/tenants', body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type GetTenantParams = {
  tenant_id: string;
};
export type GetTenantResponse = Tenant;

export async function getTenant(
  { api_url, headers }: ApiConfig,
  params: GetTenantParams
) {
  try {
    let res = await axios.get<GetTenantResponse>(api_url+'/api/users/me/tenants/'+params.tenant_id, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}

export type UpdateTenantParams = {
  tenant_id: string;
  body: PartialUpdateEntity<Pick<Tenant, 
    |'title'|'description'|'state'|'username'|'providers'|'fqdn'|'signup_role_id'
    |'custom_domains'|'auto_link_email'
  >>,
};
export type UpdateTenantResponse = {
  request_id: string;
};

export async function updateTenant(
  { api_url, headers }: ApiConfig,
  params: UpdateTenantParams
) {
  try {
    let res = await axios.patch<UpdateTenantResponse>(api_url+'/api/users/me/tenants/'+params.tenant_id, params.body, {
      headers,
    });
    return res.data;
  } catch(err) {
    throw toSerializedError(err);
  }
}
